import type { FC, CSSProperties } from 'react';

interface Props {
  href: SVG;
  className?: string;
  style?: CSSProperties;
  size?: number;
}

const Icon: FC<Props> = ({ href, className, style, size }) => {
  if (!href) {
    return null;
  }
  return (
    <svg
      viewBox={`${href.viewBox}`}
      className={className}
      style={{ width: size, height: size, flexShrink: 0, ...style }}
    >
      <use xlinkHref={`#${href.id}`} />
    </svg>
  );
};

Icon.displayName = 'Icon';

export default Icon;
